import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios'
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin'
import { CgNametag } from "react-icons/cg";
import { FaQuidditch } from "react-icons/fa";
import AdminTopNavbar from './AdminTopNavbar';

const Category = () => {
    const [categoryName, setCategoryName] = useState('');
  const [categoryCode, setCategoryCode] = useState('');
  const [categoryId, setCategoryId] = useState(null);
  const [message, setMessage] = useState('');

  // Fetch the next category ID when the component mounts or after saving
  const fetchNextCategoryId = async () => {
    try {
      const response = await axios.get('/api/next-category-id');
      setCategoryId(response.data.categoryId);
    } catch (error) {
      console.error('Error fetching next category ID:', error);
    }
  };

  useEffect(() => {
    fetchNextCategoryId();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Save the category
      const response = await axios.post('/api/add-category', {
        categoryName,
        categoryCode,
      });

      // Show success message
      setMessage('Category saved successfully!');

      // Clear the category name input field
      setCategoryName('');
      setCategoryCode('')

      // Fetch the next category ID immediately
      fetchNextCategoryId();
    } catch (error) {
      setMessage('Failed to save category');
      console.error(error);
    }
  };

  return (
    <div>
      <AdminTopNavbar/>
        <div class="content-wrapper" style={{ paddingTop: '100px' }}>
         
       
       

 <div>
    <div class="containerorder"  >
    <div className="row">
          <div class="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
            <LeftSideNavaBarAdmin /></div>

             <div class="col-xl-9 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
             <div className="admin-category-form">
      <h2>Category Form</h2>
      <div className="category-details">
        <div style={{display:"flex",justifyContent:"space-between"}}>
        <p><strong>< CgNametag style={{color:"green",fontSize:"24px"}}/> 
        Category ID:</strong> {categoryId}</p>
        <p><strong>< FaQuidditch style={{fontSize:"24px"}}/> Category Name:</strong></p>
        </div>
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder="Enter category name"
          required
          className="category-input"
        />
        <input
          type="text"
          value={categoryCode}
          onChange={(e) => setCategoryCode(e.target.value)}
          placeholder="Enter category code"
          required
          className="category-input"
        />
      </div>
      <button onClick={handleSubmit} className="save-button">Save</button>
      {message && <p className="message">{message}</p>}
      
      <style jsx>{`
        .admin-category-form {
          font-family: Arial, sans-serif;
          max-width: 600px;
          margin: 20px auto;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          border: 1px solid #2490eb;

        }
        
        h2 {
          text-align: center;
          margin-bottom: 20px;
          color: #333;
        }
        
        .category-details {
          margin-bottom: 20px;
        }
        
        .category-details p {
          font-size: 16px;
          margin-bottom: 8px;
          color: #555;
        }
        
        .category-input {
          width: 100%;
          padding: 10px;
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-bottom: 20px;
          outline: none;
          transition: border-color 0.3s;
        }

        .category-input:focus {
          border-color: #007bff;
        }

        .save-button {
          width: 100%;
          padding: 12px;
          font-size: 16px;
          background-color: #28a745;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        .save-button:hover {
          background-color: #218838;
        }

        .message {
          text-align: center;
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
                     </div>
              
         </div>
     </div>   
 </div>          
</div>

    </div>
  )
}

export default Category





